export default __webpack_public_path__ + "static/media/finance-logo-2.84fce00e.svg";